export const SEARCH = 'search';
export const ITINERARY = 'itinerary';

export function setNavigation($store, value) {
  $store.dispatch('itineraryModule/setSideBarNavigation', value);
}
